import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-text-input',
  templateUrl: './text-input.component.html',
  styleUrl: './text-input.component.scss'
})
export class TextInputComponent {
  @Input({ required: false }) label?: string;
  @Input({ required: true }) placeholder: string;
  @Input({ required: false }) errorMessage?: string;
  @Input({ required: true }) control: FormControl;
  @Input({ required: false }) type: "text" | "number" | "password";
  @Input({ required: false }) showPasswordToggle: boolean = false;
  @Input({ required: false }) maxLength?: number;
  @Input({ required: false }) inputDir?: "ltr" | "rtl";

  showPassword: boolean = false;

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  get inputType(): string {
    if (this.type === 'password' && this.showPasswordToggle) {
      return this.showPassword ? 'text' : 'password';
    }
    return this.type || 'text';
  }

  isInvalid(): boolean {
    const control = this.control;
    return control ? control.invalid && (control.dirty || control.touched) : false;
  }
}
